<template>
  <nav class="navbar app-navbar navbar-toggleable-md">
    <div class="navbar-brand-container d-flex align-items-center justify-content-start">

    </div>
    <div class="row navbar-container">

      <div class="menu-icon-container d-flex align-items-center justify-content-center justify-content-lg-start col">
        <a class="menu-icon i-menu-expanded" href="#" @click.prevent="toggleSidebar(false)" v-if="sidebarOpened"></a>
        <a class="menu-icon i-menu-collapsed" href="#" @click.prevent="toggleSidebar(true)" v-else></a>
      </div>
      <a class=" col nav-item navbar-brand mr-0 text-center brand-logo" href="#">
            {{appname}}
      </a>

      <!--<div class="col nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center" v-dropdown>
        <a class="nav-link dropdown-toggle d-flex align-items-center justify-content" href="#" @click.prevent="closeMenu">
          <span class="i-nav-messages notify"></span>
        </a>
        <div class="dropdown-menu">
          <div class="dropdown-menu-content" v-for="(note, index)  in notifications" :key="note.id">
            <a class="dropdown-item" href="#">
              <span class="ellipsis">{{note.text}}</span>
            </a>
            <div class="dropdown-item plain-link-item" v-if="index==notifications.length-1">
              <a class="plain-link" href="#">{{ $t('See all messages') }}</a>
            </div>
          </div>
        </div>
      </div>-->

      <div class="col nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center" v-dropdown>
        <a class="nav-link dropdown-toggle d-flex align-items-center justify-content" href="#" @click.prevent="closeMenu">
          <span class="avatar-container">
             &nbsp;
          </span>
        </a>
        <div class="dropdown-menu last">
          <div class="dropdown-menu-content">
              <div class="dropdown-item ">
                  <span>Hello, {{uname}}</span>
              </div>
              <div class="dropdown-item ">
                  <h4 class="balance"><span>{{ $t('My Balance:') }}</span> {{bal | currency('USD&nbsp;')}}</h4>
              </div>
            <div class="dropdown-item plain-link-item">
              <a class="plain-link" href="#" v-on:click="toProfile">{{ $t('My Profile') }}</a>
            </div>
            <div class="dropdown-item plain-link-item">
              <a class="plain-link" href="#" v-on:click="toLogout">{{ $t('Logout') }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import Dropdown from 'directives/Dropdown'
  import axios from 'axios'

  export default {
    name: 'navbar',
    data () {
      return {
        notifications: []
      }
    },
    directives: {
      dropdown: Dropdown
    },
    mounted: function () {
      this.refreshNotifications()
      this.intervalId1 = setInterval(() => {
        this.refreshNotifications()
      }, 30000)
    },
    created: function () {

    },
    computed: {
      ...mapGetters([
        'sidebarOpened',
        'toggleWithoutAnimation'
      ]),
      bal () {
        if (!this.$store.state.user) return 0
        return this.$store.state.user.balance
      },
      uname () {
        if (!this.$store.state.user || this.$store.state.user.name === null) return 'User'
        return this.$store.state.user.name
      },
      appname () {
        if (!this.$store.state.settings || this.$store.state.settings.appname === null) return 'MikiPay'
        return this.$store.state.settings.appname
      }
    },
    methods: {
      ...mapActions([
        'closeMenu',
        'toggleSidebar',
        'isToggleWithoutAnimation'
      ]),
      refreshNotifications () {
        // console.log('Notifications from', this.$router.currentRoute.path)
        if (this.$router.currentRoute.path.match('auth') || this.$router.currentRoute.path.match('invoice')) {
          // console.log('Update Paused. Unauthorized')
        } else {
          axios.get('/notifications')
            .then(response => {
              if (response !== undefined && response.data !== undefined) {
                this.notifications = response.data.data.notifications
                this.$store.commit('refresh', response.data.data.user)
                if (response.data.data.settings !== undefined) {
                  this.$store.commit('appsettings', response.data.data.settings)
                }
              }
            })
            .catch(e => {
              // console.log(e)
            })
        }
      },
      toLogout () {
        this.$store.commit('logout')
        this.$router.push('/auth/login')
      },
      toProfile () {
        this.$router.push('/profile')
      }
    }
  }
</script>

<style lang="scss">
  @import "../../../sass/_variables.scss";
  @import "../../../../node_modules/bootstrap/scss/mixins/breakpoints";
  @import "../../../../node_modules/bootstrap/scss/variables";

  .balance{
      margin-bottom: 0.3em;
      margin-top: 0.7em;
      span{
          display: block;
          font-size: $font-size-mini;
          color: $light-gray;
      }
  }

  .navbar.app-navbar {
    .navbar-container {
      width: 100%;
      height: 100%;
      margin: 0;
    }

    height: $top-nav-height;
    padding-left: $nav-padding-left;
    padding-right: $nav-padding-right;
    background-color: $top-nav-bg;

    .avatar-container {
      display: inline-block;
      width: 50px;
      height: 50px;
      background-color: white;
      border-radius: 50%;
      border: 2px solid $lighter-gray;
      overflow: hidden;

      img {
        height: 100%;
        width: 100%;
      }
    }

    .menu-icon-container {
      padding: 0;
      font-size: $font-size-base;
    }

    .navbar-brand-container {
      position: absolute;
      z-index: 3;
      height: 100%;
      left: $navbar-brand-container-left;
      top: 0;
    }

    .nav-item {
      padding: 0;
      height: 100%;
    }

    .dropdown.navbar-dropdown {
      .dropdown-toggle {
        padding: 0;
        &:after {
           display: none;
         }
      }

      &.show {
        @include media-breakpoint-up(lg) {
          .dropdown-menu {
            left: auto;
            right: 0;
          }
        }
        &:after {
           position: absolute;
           bottom: -$dropdown-show-b;
           right: calc(50% - 10px);
           width: 0;
           height: 0;
           display: block;
           content: '';
           border-left: 10px solid transparent;
           border-right: 10px solid transparent;
           border-bottom: 10px solid $darkest-gray;
         }
      }

      .dropdown-menu {
        margin-top: $dropdown-show-b;
        padding-top: 0;
        width: 100%;
      }


      .dropdown-item {
        height: $navbar-dd-item-height;
        cursor: pointer;
        font-size: $font-size-base;

        &:hover, &:active, &:focus, &.active {
          outline: none;
        }

        &.plain-link-item {
          color: $brand-primary;

          &:hover, &:active, &:focus {
            background: $dropdown-background;
          }

          .plain-link {
            text-decoration: none;
          }
        }
      }
    }

    .notify {
      position: relative;

      &::after {
         content: '';
         position: absolute;
         right: -6px;
         top: -6px;
         background-color: $brand-primary;
         height: 12px;
         width: 12px;
         border-radius: 50%;
       }
    }

    .i-nav-notification.notify::after {
      right: -4px;
      top: 0;
    }
    .navbar-brand {
      padding: 0;
      font-size: $font-size-h4+1rem;
      text-transform: uppercase;
      letter-spacing: 0.3rem;
      position: relative;
      margin-top: 0rem;
    }
    @include media-breakpoint-down(md) {

      height: 0rem;
      padding: 1.9rem $nav-mobile-padding-h $nav-mobile-pb $nav-mobile-padding-h;


        .navbar-brand {
            text-align: center;
            width: 100%;
            display: block;
            padding: 0;
            font-size: $font-size-h4;
            letter-spacing: 0.3rem;
            margin-top: -1rem;
            font-size: $font-size-h4
        }
      .dropdown.navbar-dropdown {
        &.show {
          display: flex;
          &:after {
            bottom: -$dropdown-mobile-show-b;
            z-index: 2;
          }
          .dropdown-menu {
            margin-top: $dropdown-mobile-show-b;
            left: auto;
            &.last {
              right: 0;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/navbar/Navbar.vue